<template>
  <div class="onboarding-sidebar">
    <img
      src="@/assets/icons/promo-full-light.svg"
      class="logo"
      alt="promo.ai"
    >
    <div class="icon-wrap">
      <slot name="icon">
        <v-icon
          name="rocket"
          scale="3"
          class="icon v-center"
        />
      </slot>
    </div>

    <p
      v-if="label"
      class="label"
    >
      {{ label }}
    </p>

    <p
      v-if="heading"
      class="heading"
    >
      {{ heading }}
    </p>

    <p
      v-if="subheading"
      class="subheading"
    >
      {{ subheading }}
    </p>
  </div>
</template>

<script>
export default {
  name: "OnboardingSidebar",
  props: {
    label: {
      type: String,
      default: ""
    },
    heading: {
      type: String,
      default: ""
    },
    subheading: {
      type: String,
      default: ""
    }
  }
};
</script>

<style scoped>
.onboarding-sidebar {
  @apply w-full px-4 pt-10 pb-6 rounded-t-lg;
  background: linear-gradient(167.46deg, #707fd8 0%, #4354b4 97.37%);

  @screen lg {
    @apply pb-10 rounded-t-none rounded-l-lg;
    min-height: 500px;
    width: 280px;
  }
}

.icon-wrap {
  @apply mb-10;
  height: 120px;
  width: 120px;
}

.icon {
  @apply text-brand;
}

.label {
  @apply uppercase font-light font-sans text-xs text-brand-light tracking-wide mb-4;
}

.heading {
  @apply font-lato text-white text-xl font-black leading-tight mb-4;
}

.subheading {
  @apply text-xs text-grey-light mb-0;
}

.logo {
  @apply absolute;
  left: 8px;
  top: 9px;
  width: 89px;

  @screen md {
    left: 13px;
    top: 13px;
    width: 68px;
  }
}
</style>
